import { ExceptionReportCCDto } from './../../model/exception-report-cc-dto';
import { PdfFileService } from './../../services/pdf-file.service';
import { DatePipe } from '@angular/common';
import { ExcelFileService } from './../../services/excel-file.service';
import { FileExportService } from './../../services/file-export.service';
import { ReportDateRangeDto } from './../../model/report-date-range-dto';
import { HttpclientService } from './../../services/httpclient.service';
import { AppSettingService } from './../../services/app-setting.service';
import { Component, OnInit, TemplateRef } from '@angular/core';
import * as moment from 'moment';
import { PoOrderByPipe } from 'src/app/pipes/po-order-by.pipe';
import { ExceptionReportDto } from 'src/app/model/exception-report-dto';
import { ModalModule, BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-monthly-exceptions-report-cc',
  templateUrl: './monthly-exceptions-report-cc.component.html',
  styleUrls: ['./monthly-exceptions-report-cc.component.css']
})
export class MonthlyExceptionsReportCCComponent implements OnInit {
maxDateMerm: moment.Moment;
modalPopup : boolean=false;
modalPopupString: string;
dateRangeMerm;
dateRangeStartMerm;
dateRangeEndMerm;
exportModalMerm: string;
selectAllRowModalMerm: boolean;
public loadingMerm: boolean;
 paginationConfigurationMerm;
reportDateRangeDto: ReportDateRangeDto;
exceptionReportDtoM2mListCC: ExceptionReportCCDto[]=[];
sortArry: ExceptionReportCCDto[];
exceptionReportDtoCCSelectedList: ExceptionReportCCDto[];
selectedMermDto: any = [];
paginationCountMerm = 25;
modalRef: BsModalRef;
responseContents: any;


isCreatedDateCCUpArrow: boolean;
isCreatedDateCCDownArrow: boolean;
isYearCCUpArrow: boolean;
isYearCCDownArrow: boolean;
isMonthCCTextArrow: boolean;
isMonthCCTextDownArrow: boolean;
isDistributorPayerCCUpArrow: boolean;
isDistributorPayerCCDownArrow: boolean;
isPurchaseOrderNumberCCTextArrow: boolean;
isPurchaseOrderNumberCCTextDownArrow: boolean;
isSupplierDocRefNumberCCTextArrow: boolean;
isSupplierDocRefNumberCCTextDownArrow: boolean;
isItemErrorCodeCCTextArrow: boolean;
isItemErrorCodeCCTextDownArrow: boolean;
isItemErrorDescriptionCCTextArrow: boolean;
isItemErrorDescriptionCCTextDownArrow: boolean;



// sortArry: ExceptionReportDto[];
  constructor(public appSettingService: AppSettingService, private httpclientService: HttpclientService,
              public fileExportService: FileExportService, public excelFileService: ExcelFileService, public datePipe: DatePipe,
              public pdfFileService: PdfFileService, private pipe: PoOrderByPipe, private modalService: BsModalService) { }

  ngOnInit() {
    this.maxDateMerm = moment().add(0, 'days');
    this.exportModalMerm = this.appSettingService.exportList[0];
    this.paginationConfigurationMerm = { currentPage: '25 per page', itemsPerPage: '25' };
    this.dateRangeMerm = '';
    this.initialSortValue();
  }
/****************************************************** Clear Selction Start ***************************************************/
pageOnChangedMerm(event) {
  this.paginationConfigurationMerm.currentPage = event;
}

exportDataOnChangeMerm(exportData) {
  this.exportModalMerm = exportData;
}

onSelectParticularRowMerm(selectedItem: any, values: any) {
  if (values.currentTarget.checked) {
    this.fileExportService.selectedMonthlyExceptionsReportCcData1.push(selectedItem);
  } else if (!values.currentTarget.checked) {
    this.fileExportService.selectedMonthlyExceptionsReportCcData1 = this.fileExportService.selectedMonthlyExceptionsReportCcData1.filter(obj => obj !== selectedItem);
  }
  if (this.fileExportService.selectedMonthlyExceptionsReportCcData1.length === this.exceptionReportDtoCCSelectedList.length) {
    this.selectAllRowModalMerm = true;
  } else {
    this.selectAllRowModalMerm = false;
  }
}
onChangePaginationMerm(value) {
  
    this.paginationConfigurationMerm.itemsPerPage = value;
    this.paginationCountMerm = value;
  }
onSelectAllRowMerm(values: any) {
  this.exceptionReportDtoCCSelectedList = [];
  if (values.currentTarget.checked) {
    this.exceptionReportDtoM2mListCC.forEach(pdto => {
      pdto.rowCheck = true;
      this.exceptionReportDtoCCSelectedList.push(pdto);
    });
    this.exceptionReportDtoM2mListCC = this.exceptionReportDtoCCSelectedList;
    this.fileExportService.selectedMonthlyExceptionsReportCcData1 = this.exceptionReportDtoCCSelectedList;
  } else {
    this.exceptionReportDtoM2mListCC.forEach(pdto => {
      pdto.rowCheck = false;
      this.exceptionReportDtoCCSelectedList.push(pdto);
    });
    this.exceptionReportDtoM2mListCC = this.exceptionReportDtoCCSelectedList;
    this.fileExportService.selectedMonthlyExceptionsReportCcData1 = [];
  }
   }

exportFileOnClickMerm() {
  console.log('.....this.exceptionReportDtoM2mList..' + this.exceptionReportDtoM2mListCC.length);
  if (this.exceptionReportDtoM2mListCC === null || this.exceptionReportDtoM2mListCC.length === 0) {
    this.modalPopupString="No Data to Export";
    this.modalPopup=true;
  } else if (this.fileExportService.selectedMonthlyExceptionsReportCcData1.length === 0 && this.exceptionReportDtoM2mListCC.length !== 0) {
    if (this.exportModalMerm === 'PDF') {
      this.pdfFileService.exportMonthlyExceptionReportCCPdfAll('Monthly Exceptions Report CC', this.exceptionReportDtoM2mListCC);
    } else if (this.exportModalMerm === 'Excel') {
      this.selectedMermDto = [];
      this.exceptionReportDtoM2mListCC.forEach(pdto => {
          let fileId: any;
          let supplierDocRefNumber: any;
          let year: any;
          let month: any;
          let distributorName: any;
          let refCodeName: any;
          let refcodeid: any;
          let purchaseOrderNumber: any;
          let itemErrorCode: any;
          let itemErrorDescription: any;
          let datetimeOfCreation: any;

          
          if (pdto.fileId === null) {
            fileId = '';
          } else {
            fileId = pdto.fileId;
          }
          if (pdto.supplierDocRefNumber === null) {
            supplierDocRefNumber = '';
          } else {
            supplierDocRefNumber = pdto.supplierDocRefNumber;
          }
          if (pdto.year === null) {
            year = '';
          } else {
            year = pdto.year;
          }
          if (pdto.month === null) {
            month = '';
          } else {
            month = pdto.month;
          }
          if (pdto.distributorName === null) {
            distributorName = '';
          } else {
            distributorName = pdto.distributorName;
          }
          if (pdto.refCodeName === null) {
            refCodeName = '';
          } else {
            refCodeName = pdto.refCodeName;
          }
          if (pdto.refcodeid === null) {
            refcodeid = '';
          } else {
            refcodeid = pdto.refcodeid;
          }
          if (pdto.purchaseOrderNumber === null) {
            purchaseOrderNumber = '';
          } else {
            purchaseOrderNumber = pdto.purchaseOrderNumber;
          }
          if (pdto.itemErrorCode === null) {
            itemErrorCode = '';
          } else {
            itemErrorCode = pdto.itemErrorCode;
          }
          if (pdto.itemErrorDescription === null) {
            itemErrorDescription = '';
          } else {
            itemErrorDescription = pdto.itemErrorDescription;
          }
          if (pdto.datetimeOfCreation === null) {
            datetimeOfCreation = '';
          } else {
            datetimeOfCreation = this.datePipe.transform(pdto.datetimeOfCreation, this.appSettingService.globelDatePickerInUSAFormat);
          }

          this.selectedMermDto.push({
            'Created Date': `` +datetimeOfCreation, Year: `` +year,
            Month: `` + month, 'Distributor Payer': `` + distributorName,
            'Purchase Order Number': `` + purchaseOrderNumber, SupplierDocRefNumber: `` + supplierDocRefNumber,
            'Item Error Code':``+itemErrorCode, 'Item Error Description':``+itemErrorDescription
          });
        
      });
      this.excelFileService.exportMonthlyExceptionReportCCExcel(this.selectedMermDto, 'Monthly Exceptions Report CC');
    }

  } else if( this.fileExportService.selectedMonthlyExceptionsReportCcData1.length !== 0 && this.exceptionReportDtoM2mListCC.length !== 0) {
    if (this.exportModalMerm === 'PDF') {
      this.pdfFileService.exportMonthlyExceptionReportCCPdf('Monthly Exceptions Report CC');
    } else if (this.exportModalMerm === 'Excel') {
      this.selectedMermDto = [];
      this.fileExportService.selectedMonthlyExceptionsReportCcData1.forEach(pdto => {
        if (pdto.rowCheck) {
          let fileId: any;
          let supplierDocRefNumber: any;
          let year: any;
          let month: any;
          let distributorName: any;
          let refCodeName: any;
          let refcodeid: any;
          let purchaseOrderNumber: any;
          let itemErrorCode: any;
          let itemErrorDescription: any;
          let datetimeOfCreation: any;

          
          if (pdto.fileId === null) {
            fileId = '';
          } else {
            fileId = pdto.fileId;
          }
          if (pdto.supplierDocRefNumber === null) {
            supplierDocRefNumber = '';
          } else {
            supplierDocRefNumber = pdto.supplierDocRefNumber;
          }
          if (pdto.year === null) {
            year = '';
          } else {
            year = pdto.year;
          }
          if (pdto.month === null) {
            month = '';
          } else {
            month = pdto.month;
          }
          if (pdto.distributorName === null) {
            distributorName = '';
          } else {
            distributorName = pdto.distributorName;
          }
          if (pdto.refCodeName === null) {
            refCodeName = '';
          } else {
            refCodeName = pdto.refCodeName;
          }
          if (pdto.refcodeid === null) {
            refcodeid = '';
          } else {
            refcodeid = pdto.refcodeid;
          }
          if (pdto.purchaseOrderNumber === null) {
            purchaseOrderNumber = '';
          } else {
            purchaseOrderNumber = pdto.purchaseOrderNumber;
          }
          if (pdto.itemErrorCode === null) {
            itemErrorCode = '';
          } else {
            itemErrorCode = pdto.itemErrorCode;
          }
          if (pdto.itemErrorDescription === null) {
            itemErrorDescription = '';
          } else {
            itemErrorDescription = pdto.itemErrorDescription;
          }
          if (pdto.datetimeOfCreation === null) {
            datetimeOfCreation = '';
          } else {
            datetimeOfCreation = this.datePipe.transform(pdto.datetimeOfCreation, this.appSettingService.globelDatePickerInUSAFormat);
          }


          this.selectedMermDto.push({
            'Created Date': `` +datetimeOfCreation, Year: `` +year,
            Month: `` + month, 'Distributor Payer': `` + distributorName,
            'Purchase Order Number': `` + purchaseOrderNumber, SupplierDocRefNumber: `` + supplierDocRefNumber,
            'Item Error Code':``+itemErrorCode, 'Item Error Description':``+itemErrorDescription
          });
        }
      });
      this.excelFileService.exportMonthlyExceptionReportCCExcel(this.selectedMermDto, 'Monthly Exceptions Report CC');
    }
  }
}


initialSortValue() {
  this.isCreatedDateCCUpArrow = true;
  this.isCreatedDateCCDownArrow = true;
  this.isYearCCUpArrow = true;
  this.isYearCCDownArrow = true;
  this.isMonthCCTextArrow = true;
  this.isMonthCCTextDownArrow = true;
  this.isDistributorPayerCCUpArrow = true;
  this.isDistributorPayerCCDownArrow = true;
  this.isPurchaseOrderNumberCCTextArrow = true;
  this.isPurchaseOrderNumberCCTextDownArrow = true;
  this.isSupplierDocRefNumberCCTextArrow = true;
  this.isSupplierDocRefNumberCCTextDownArrow = true;
  this.isItemErrorCodeCCTextArrow = true;;
  this.isItemErrorCodeCCTextDownArrow = true;
  this.isItemErrorDescriptionCCTextArrow = true;
  this.isItemErrorDescriptionCCTextDownArrow = true;

}
  clearAllSelection() {
     this.selectAllRowModalMerm = false;
     this.initialSortValue();
    // this.clearMlrSelection = [];
    // this.monthlyLocationDtoList.forEach(pdto => {
    //   pdto.rowCheck = false;
    //   this.clearMlrSelection.push(pdto);
    // });
    // this.monthlyLocationDtoList = this.clearMlrSelection;
  }
/****************************************************** Clear Selction End ***************************************************/



/****************************************************** Date Picker Block Start ***************************************************/
pressingOK(){
  this.modalPopup=false;
}
dateOnChangeMermCC() {
  this.fileExportService.selectedMonthlyExceptionsReportCcData1 = [];
  if (this.dateRangeMerm.dateRangeStartMerm !== undefined &&
    this.dateRangeMerm.dateRangeStartMerm !== null) {
   
    this.reportDateRangeDto = {
      start: this.dateRangeMerm.dateRangeStartMerm.format('YYYY-MM-DD'),
      end: this.dateRangeMerm.dateRangeEndMerm.format('YYYY-MM-DD'),
    };
    this.loadingMerm = true;
    this.httpclientService.getMonthlyExceptionsReportCC(this.reportDateRangeDto).subscribe(
      data => {
        this.clearAllSelection();
        this.exceptionReportDtoM2mListCC = data;
        this.loadingMerm = false;
      }
    );
  }
}

onChangeMermSort(event: any, upDown: boolean, propertyName: string) {
  if (propertyName === 'datetimeOfCreation' ) {
    this.isYearCCUpArrow = true;
    this.isYearCCDownArrow = true;
    this.isMonthCCTextArrow = true;
    this.isMonthCCTextDownArrow = true;
    this.isDistributorPayerCCUpArrow = true;
    this.isDistributorPayerCCDownArrow = true;
    this.isPurchaseOrderNumberCCTextArrow = true;
    this.isPurchaseOrderNumberCCTextDownArrow = true;
    this.isSupplierDocRefNumberCCTextArrow = true;
    this.isSupplierDocRefNumberCCTextDownArrow = true;
    this.isItemErrorCodeCCTextArrow = true;;
    this.isItemErrorCodeCCTextDownArrow = true;
    this.isItemErrorDescriptionCCTextArrow = true;
    this.isItemErrorDescriptionCCTextDownArrow = true;
    if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.exceptionReportDtoM2mListCC, propertyName, upDown);
  this.exceptionReportDtoM2mListCC = [];
  this.exceptionReportDtoM2mListCC = this.sortArry;
  this.isCreatedDateCCUpArrow = !this.isCreatedDateCCUpArrow;
  this.isCreatedDateCCDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.exceptionReportDtoM2mListCC, propertyName, upDown);
this.exceptionReportDtoM2mListCC = [];
this.exceptionReportDtoM2mListCC = this.sortArry;
this.isCreatedDateCCDownArrow = !this.isCreatedDateCCDownArrow;
this.isCreatedDateCCUpArrow = true;
}
  } else if (propertyName === 'year' ) {
    this.isCreatedDateCCUpArrow = true;
    this.isCreatedDateCCDownArrow = true;
    this.isMonthCCTextArrow = true;
    this.isMonthCCTextDownArrow = true;
    this.isDistributorPayerCCUpArrow = true;
    this.isDistributorPayerCCDownArrow = true;
    this.isPurchaseOrderNumberCCTextArrow = true;
    this.isPurchaseOrderNumberCCTextDownArrow = true;
    this.isSupplierDocRefNumberCCTextArrow = true;
    this.isSupplierDocRefNumberCCTextDownArrow = true;
    this.isItemErrorCodeCCTextArrow = true;;
    this.isItemErrorCodeCCTextDownArrow = true;
    this.isItemErrorDescriptionCCTextArrow = true;
    this.isItemErrorDescriptionCCTextDownArrow = true;
    if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.exceptionReportDtoM2mListCC, propertyName, upDown);
  this.exceptionReportDtoM2mListCC = [];
  this.exceptionReportDtoM2mListCC = this.sortArry;
  this.isYearCCUpArrow = !this.isYearCCUpArrow;
  this.isYearCCDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.exceptionReportDtoM2mListCC, propertyName, upDown);
this.exceptionReportDtoM2mListCC = [];
this.exceptionReportDtoM2mListCC = this.sortArry;
this.isYearCCDownArrow = !this.isYearCCDownArrow;
this.isYearCCUpArrow = true;
}
  } else if (propertyName === 'month' ) {
    this.isCreatedDateCCUpArrow = true;
    this.isCreatedDateCCDownArrow = true;
    this.isYearCCUpArrow = true;
    this.isYearCCDownArrow = true;
    this.isDistributorPayerCCUpArrow = true;
    this.isDistributorPayerCCDownArrow = true;
    this.isPurchaseOrderNumberCCTextArrow = true;
    this.isPurchaseOrderNumberCCTextDownArrow = true;
    this.isSupplierDocRefNumberCCTextArrow = true;
    this.isSupplierDocRefNumberCCTextDownArrow = true;
    this.isItemErrorCodeCCTextArrow = true;;
    this.isItemErrorCodeCCTextDownArrow = true;
    this.isItemErrorDescriptionCCTextArrow = true;
    this.isItemErrorDescriptionCCTextDownArrow = true;
    if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.exceptionReportDtoM2mListCC, propertyName, upDown);
  this.exceptionReportDtoM2mListCC = [];
  this.exceptionReportDtoM2mListCC = this.sortArry;
  this.isMonthCCTextArrow = !this.isMonthCCTextArrow;
  this.isMonthCCTextDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.exceptionReportDtoM2mListCC, propertyName, upDown);
this.exceptionReportDtoM2mListCC = [];
this.exceptionReportDtoM2mListCC = this.sortArry;
this.isMonthCCTextDownArrow = !this.isMonthCCTextDownArrow;
this.isMonthCCTextArrow = true;
}
  } else if (propertyName === 'distributorName' ) {
    this.isCreatedDateCCUpArrow = true;
    this.isCreatedDateCCDownArrow = true;
    this.isYearCCUpArrow = true;
    this.isYearCCDownArrow = true;
    this.isMonthCCTextArrow = true;
    this.isMonthCCTextDownArrow = true;
    this.isPurchaseOrderNumberCCTextArrow = true;
    this.isPurchaseOrderNumberCCTextDownArrow = true;
    this.isSupplierDocRefNumberCCTextArrow = true;
    this.isSupplierDocRefNumberCCTextDownArrow = true;
    this.isItemErrorCodeCCTextArrow = true;;
    this.isItemErrorCodeCCTextDownArrow = true;
    this.isItemErrorDescriptionCCTextArrow = true;
    this.isItemErrorDescriptionCCTextDownArrow = true;
    if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.exceptionReportDtoM2mListCC, propertyName, upDown);
  this.exceptionReportDtoM2mListCC = [];
  this.exceptionReportDtoM2mListCC = this.sortArry;
  this.isDistributorPayerCCUpArrow = !this.isDistributorPayerCCUpArrow;
  this.isDistributorPayerCCDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.exceptionReportDtoM2mListCC, propertyName, upDown);
this.exceptionReportDtoM2mListCC = [];
this.exceptionReportDtoM2mListCC = this.sortArry;
this.isDistributorPayerCCDownArrow = !this.isDistributorPayerCCDownArrow;
this.isDistributorPayerCCUpArrow = true;
}
  } else if (propertyName === 'purchaseOrderNumber' ) {
    this.isCreatedDateCCUpArrow = true;
    this.isCreatedDateCCDownArrow = true;
    this.isYearCCUpArrow = true;
    this.isYearCCDownArrow = true;
    this.isMonthCCTextArrow = true;
    this.isMonthCCTextDownArrow = true;
    this.isDistributorPayerCCUpArrow = true;
    this.isDistributorPayerCCDownArrow = true;
    this.isSupplierDocRefNumberCCTextArrow = true;
    this.isSupplierDocRefNumberCCTextDownArrow = true;
    this.isItemErrorCodeCCTextArrow = true;;
    this.isItemErrorCodeCCTextDownArrow = true;
    this.isItemErrorDescriptionCCTextArrow = true;
    this.isItemErrorDescriptionCCTextDownArrow = true;
    if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.exceptionReportDtoM2mListCC, propertyName, upDown);
  this.exceptionReportDtoM2mListCC = [];
  this.exceptionReportDtoM2mListCC = this.sortArry;
  this.isPurchaseOrderNumberCCTextArrow = !this.isPurchaseOrderNumberCCTextArrow;
  this.isPurchaseOrderNumberCCTextDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.exceptionReportDtoM2mListCC, propertyName, upDown);
this.exceptionReportDtoM2mListCC = [];
this.exceptionReportDtoM2mListCC = this.sortArry;
this.isPurchaseOrderNumberCCTextDownArrow = !this.isPurchaseOrderNumberCCTextDownArrow;
this.isPurchaseOrderNumberCCTextArrow = true;
}
  } else if (propertyName === 'supplierDocRefNumber' ) {
    this.isCreatedDateCCUpArrow = true;
    this.isCreatedDateCCDownArrow = true;
    this.isYearCCUpArrow = true;
    this.isYearCCDownArrow = true;
    this.isMonthCCTextArrow = true;
    this.isMonthCCTextDownArrow = true;
    this.isDistributorPayerCCUpArrow = true;
    this.isDistributorPayerCCDownArrow = true;
    this.isPurchaseOrderNumberCCTextArrow = true;
    this.isPurchaseOrderNumberCCTextDownArrow = true;
    this.isItemErrorCodeCCTextArrow = true;;
    this.isItemErrorCodeCCTextDownArrow = true;
    this.isItemErrorDescriptionCCTextArrow = true;
    this.isItemErrorDescriptionCCTextDownArrow = true;
    if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.exceptionReportDtoM2mListCC, propertyName, upDown);
  this.exceptionReportDtoM2mListCC = [];
  this.exceptionReportDtoM2mListCC = this.sortArry;
  this.isSupplierDocRefNumberCCTextArrow = !this.isSupplierDocRefNumberCCTextArrow;
  this.isSupplierDocRefNumberCCTextDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.exceptionReportDtoM2mListCC, propertyName, upDown);
this.exceptionReportDtoM2mListCC = [];
this.exceptionReportDtoM2mListCC = this.sortArry;
this.isSupplierDocRefNumberCCTextDownArrow = !this.isSupplierDocRefNumberCCTextDownArrow;
this.isSupplierDocRefNumberCCTextArrow = true;
}
  }
  else if (propertyName === 'itemErrorCode' ) {
    this.isCreatedDateCCUpArrow = true;
    this.isCreatedDateCCDownArrow = true;
    this.isYearCCUpArrow = true;
    this.isYearCCDownArrow = true;
    this.isMonthCCTextArrow = true;
    this.isMonthCCTextDownArrow = true;
    this.isDistributorPayerCCUpArrow = true;
    this.isDistributorPayerCCDownArrow = true;
    this.isPurchaseOrderNumberCCTextArrow = true;
    this.isPurchaseOrderNumberCCTextDownArrow = true;
    this.isItemErrorDescriptionCCTextArrow = true;
    this.isItemErrorDescriptionCCTextDownArrow = true;
    if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.exceptionReportDtoM2mListCC, propertyName, upDown);
  this.exceptionReportDtoM2mListCC = [];
  this.exceptionReportDtoM2mListCC = this.sortArry;
  this.isItemErrorCodeCCTextArrow = !this.isItemErrorCodeCCTextArrow;
  this.isItemErrorCodeCCTextDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.exceptionReportDtoM2mListCC, propertyName, upDown);
this.exceptionReportDtoM2mListCC = [];
this.exceptionReportDtoM2mListCC = this.sortArry;
this.isItemErrorCodeCCTextDownArrow = !this.isItemErrorCodeCCTextDownArrow;
this.isItemErrorCodeCCTextArrow = true;
}
  }
  else if (propertyName === 'itemErrorDescription' ) {
    this.isCreatedDateCCUpArrow = true;
    this.isCreatedDateCCDownArrow = true;
    this.isYearCCUpArrow = true;
    this.isYearCCDownArrow = true;
    this.isMonthCCTextArrow = true;
    this.isMonthCCTextDownArrow = true;
    this.isDistributorPayerCCUpArrow = true;
    this.isDistributorPayerCCDownArrow = true;
    this.isPurchaseOrderNumberCCTextArrow = true;
    this.isPurchaseOrderNumberCCTextDownArrow = true;
    this.isItemErrorCodeCCTextArrow = true;;
    this.isItemErrorCodeCCTextDownArrow = true;
    if (upDown) {
  this.sortArry = [];
  this.sortArry = this.pipe.transform(this.exceptionReportDtoM2mListCC, propertyName, upDown);
  this.exceptionReportDtoM2mListCC = [];
  this.exceptionReportDtoM2mListCC = this.sortArry;
  this.isItemErrorDescriptionCCTextArrow = !this.isItemErrorDescriptionCCTextArrow;
  this.isItemErrorDescriptionCCTextDownArrow = true;
} else {
this.sortArry = [];
this.sortArry = this.pipe.transform(this.exceptionReportDtoM2mListCC, propertyName, upDown);
this.exceptionReportDtoM2mListCC = [];
this.exceptionReportDtoM2mListCC = this.sortArry;
this.isItemErrorDescriptionCCTextDownArrow = !this.isItemErrorDescriptionCCTextDownArrow;
this.isItemErrorDescriptionCCTextArrow = true;
}
  }
}


}
